/* ═══════════════════════════════════════════════════════════
   HYDRATED+ KRASLOT POPUP · assets/hp-scratch-popup.js
   Native JS, geen dependencies. Config komt uit #hpspConfig
   (JSON, gevuld door theme settings in de sectie).
   Test-helpers: ?hpsp_test=1 (direct openen) · ?hpsp_test=reset
   (opslag wissen + direct openen).
═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var root = document.getElementById('hpspRoot');
    var cfgEl = document.getElementById('hpspConfig');
    if (!root || !cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); }
    catch (e) { console.warn('[HPSP] Config kon niet worden gelezen:', e); return; }

    var KEY = 'hpsp_v1';
    var DAY = 86400000;

    /* ── Opslag ────────────────────────────────────── */
    function readState() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return null;
        var o = JSON.parse(raw);
        if (!o || (o.exp && Date.now() > o.exp)) { localStorage.removeItem(KEY); return null; }
        return o;
      } catch (e) { return null; }
    }
    function saveState(patch) {
      try {
        var cur = readState() || {};
        for (var k in patch) cur[k] = patch[k];
        if (!cur.exp) cur.exp = Date.now() + (cfg.storageDays || 30) * DAY;
        localStorage.setItem(KEY, JSON.stringify(cur));
        return cur;
      } catch (e) { return patch; }
    }

    /* ── Test-helpers ───────────────────────────────── */
    var force = null;
    try { force = new URLSearchParams(window.location.search).get('hpsp_test'); } catch (e) {}
    if (force === 'reset') { try { localStorage.removeItem(KEY); } catch (e) {} }

    var state = readState();

    /* ── Onderdrukking ──────────────────────────────── */
    if (!force) {
      if (state && state.done) return;
      if (state && state.closed && Date.now() - state.closed < (cfg.cooldownDays || 3) * DAY) return;
    }

    /* ── Elementen ─────────────────────────────────── */
    function $(sel) { return root.querySelector(sel); }
    var dialog = $('[data-hpsp-dialog]');
    var overlay = $('[data-hpsp-overlay]');
    var closeBtn = $('[data-hpsp-close]');
    var steps = {
      scratch: $('[data-step="scratch"]'),
      form: $('[data-step="form"]'),
      success: $('[data-step="success"]')
    };
    var card = $('[data-hpsp-card]');
    var canvas = $('[data-hpsp-canvas]');
    var prizeEls = root.querySelectorAll('[data-hpsp-prize]');
    var revealBtn = $('[data-hpsp-reveal]');
    var form = $('#hpspForm') || $('[data-hpsp-form]') || root.querySelector('form');
    var emailInput = $('[data-hpsp-email]');
    var consentInput = $('[data-hpsp-consent]');
    var tagsInput = $('[data-hpsp-tags]');
    var optinInput = $('[data-hpsp-optin]');
    var submitBtn = $('[data-hpsp-submit]');
    var submitLabel = $('[data-hpsp-submit-label]');
    var errEl = $('[data-hpsp-error]');
    var codeEl = $('[data-hpsp-code]');
    var copyBtn = $('[data-hpsp-copy]');
    var copyLabelEl = $('[data-hpsp-copy-label]');
    var shopBtn = $('[data-hpsp-shop]');
    if (!dialog || !canvas || !card || !form) return;

    var reduced = false;
    try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    /* ── Analytics (faalt nooit) ──────────────────────── */
    function track(name, extra) {
      try {
        window.dataLayer = window.dataLayer || [];
        var o = { event: name };
        if (extra) for (var k in extra) o[k] = extra[k];
        window.dataLayer.push(o);
      } catch (e) {}
    }

    /* ── Uitkomst (gewogen, 1x per bewaartermijn) ───────── */
    function pickTier() {
      var tiers = cfg.tiers || [];
      var sum = 0, i, w;
      for (i = 0; i < tiers.length; i++) sum += Math.max(0, Number(tiers[i].weight) || 0);
      if (sum <= 0) return tiers[0];
      var r = Math.random() * sum;
      for (i = 0; i < tiers.length; i++) {
        w = Math.max(0, Number(tiers[i].weight) || 0);
        if ((r -= w) < 0) return tiers[i];
      }
      return tiers[tiers.length - 1];
    }
    function tierByPercent(p) {
      for (var i = 0; i < (cfg.tiers || []).length; i++) {
        if (Number(cfg.tiers[i].percent) === Number(p)) return cfg.tiers[i];
      }
      return null;
    }

    var tier = (state && state.p) ? tierByPercent(state.p) : null;

    /* ── Openen / sluiten ───────────────────────────── */
    var opened = false, isOpen = false, lastFocus = null, pageStart = Date.now();

    function lockScroll() {
      var sw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.classList.add('hpsp-lock');
      if (sw > 0) document.body.style.paddingRight = sw + 'px';
    }
    function unlockScroll() {
      document.documentElement.classList.remove('hpsp-lock');
      document.body.style.paddingRight = '';
    }

    function focusables() {
      return dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }
    function onKeydown(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close('escape'); return; }
      if (e.key !== 'Tab') return;
      var list = Array.prototype.filter.call(focusables(), function (el) {
        return el.offsetParent !== null && !el.disabled;
      });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function setStep(name) {
      for (var k in steps) { if (steps[k]) steps[k].hidden = (k !== name); }
      if (name === 'form') {
        track('scratch_popup_form_view', { discount: tier ? tier.percent : null });
        window.setTimeout(function () {
          try { emailInput.focus({ preventScroll: true }); } catch (e) {}
        }, reduced ? 0 : 380);
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true; opened = true;
      lastFocus = document.activeElement;

      if (!tier) {
        tier = pickTier();
        if (!tier) { console.warn('[HPSP] Geen kortingsniveaus geconfigureerd.'); return; }
        state = saveState({ p: tier.percent, t: Date.now() });
      }
      prizeEls.forEach ? prizeEls.forEach(setPrize) : Array.prototype.forEach.call(prizeEls, setPrize);
      function setPrize(el) { el.textContent = tier.percent + '%'; }

      root.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      lockScroll();
      document.addEventListener('keydown', onKeydown, true);

      if (state && state.scratched) {
        card.classList.add('is-cleared');
        setStep('form');
      } else {
        setStep('scratch');
        window.setTimeout(paintCanvas, 60);
        window.setTimeout(function () { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }, 120);
      }
      track('scratch_popup_opened', { discount: tier.percent });
    }

    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown, true);
      unlockScroll();
      window.setTimeout(function () { root.hidden = true; }, reduced ? 0 : 300);
      var cur = readState();
      if (!cur || !cur.done) saveState({ closed: Date.now() });
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      track('scratch_popup_closed', { reason: reason || 'button' });
    }

    closeBtn.addEventListener('click', function () { close('button'); });
    if (cfg.overlayClose) overlay.addEventListener('click', function () { close('overlay'); });

    /* ── Triggers ─────────────────────────────────── */
    function tryOpen() { if (!opened) open(); }
    if (force) {
      tryOpen();
    } else {
      if (cfg.delay > 0) window.setTimeout(tryOpen, cfg.delay * 1000);
      if (cfg.scrollPct > 0) {
        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h <= 0) return;
          if ((window.scrollY / h) * 100 >= cfg.scrollPct) {
            window.removeEventListener('scroll', onScroll);
            tryOpen();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      if (cfg.exitIntent) {
        var fine = false;
        try { fine = window.matchMedia('(pointer: fine)').matches; } catch (e) {}
        if (fine) {
          document.addEventListener('mouseout', function (e) {
            if (opened) return;
            if (!e.relatedTarget && e.clientY <= 10 && Date.now() - pageStart > 3000) tryOpen();
          });
        }
      }
    }

    /* ── Kras-canvas ────────────────────────────────── */
    var ctx = null, dpr = 1, cardRect = null;
    var drawing = false, started = false, revealed = false;
    var lastPt = null, moveCount = 0;

    function luminance(hex) {
      var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
      if (!m) return 1;
      return (0.299 * parseInt(m[1], 16) + 0.587 * parseInt(m[2], 16) + 0.114 * parseInt(m[3], 16)) / 255;
    }

    function paintCanvas() {
      cardRect = card.getBoundingClientRect();
      var w = Math.max(1, Math.round(cardRect.width));
      var h = Math.max(1, Math.round(cardRect.height));
      dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.scale(dpr, dpr);

      var base = cfg.colors && cfg.colors.scratch ? cfg.colors.scratch : '#d6d0c4';
      ctx.fillStyle = base;
      ctx.fillRect(0, 0, w, h);

      /* subtiele diagonale glansbanen */
      ctx.save();
      ctx.globalAlpha = 0.06;
      ctx.fillStyle = '#ffffff';
      for (var x = -h; x < w + h; x += 24) {
        ctx.save();
        ctx.translate(x, 0);
        ctx.rotate(-0.55);
        ctx.fillRect(0, -h, 7, h * 3);
        ctx.restore();
      }
      ctx.restore();

      /* fijne korrel */
      ctx.save();
      ctx.globalAlpha = 0.05;
      for (var i = 0; i < 260; i++) {
        ctx.fillStyle = Math.random() > 0.5 ? '#ffffff' : '#000000';
        ctx.fillRect(Math.random() * w, Math.random() * h, 1.2, 1.2);
      }
      ctx.restore();

      /* tekst */
      var dark = luminance(base) > 0.55;
      var main = (cfg.t && cfg.t.scratchLabel) || 'KRAS HIER';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = dark ? 'rgba(26,26,26,.6)' : 'rgba(255,255,255,.92)';
      ctx.font = '800 17px ' + (cfg.fontStack || 'system-ui, sans-serif');
      ctx.fillText(main.split('').join(' '), w / 2, h / 2 - 8);
      ctx.fillStyle = dark ? 'rgba(26,26,26,.38)' : 'rgba(255,255,255,.6)';
      ctx.font = '600 11px ' + (cfg.fontStack || 'system-ui, sans-serif');
      ctx.fillText((cfg.t && cfg.t.scratchSub) || '', w / 2, h / 2 + 14);
    }

    function pointFromEvent(e) {
      return { x: e.clientX - cardRect.left, y: e.clientY - cardRect.top };
    }

    function scratchTo(pt, isStart) {
      if (!ctx) return;
      var brush = Math.max(24, cardRect.height * 0.17);
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = brush;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      if (isStart || !lastPt) {
        ctx.arc(pt.x, pt.y, brush / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.moveTo(lastPt.x, lastPt.y);
        ctx.lineTo(pt.x, pt.y);
        ctx.stroke();
      }
      ctx.restore();
      lastPt = pt;
    }

    function scratchedPercent() {
      if (!ctx) return 0;
      var data;
      try { data = ctx.getImageData(0, 0, canvas.width, canvas.height).data; }
      catch (e) { return 0; }
      var total = 0, clear = 0;
      for (var i = 3; i < data.length; i += 92) { /* alpha-samples met stride */
        total++;
        if (data[i] < 128) clear++;
      }
      return total ? (clear / total) * 100 : 0;
    }

    function onScratchStart() {
      if (started) return;
      started = true;
      card.classList.add('is-started');
      track('scratch_popup_scratch_started', { discount: tier.percent });
    }

    function complete(via) {
      if (revealed) return;
      revealed = true;
      state = saveState({ scratched: true });
      card.classList.add('is-cleared');
      track('scratch_popup_completed', { discount: tier.percent });
      track('scratch_popup_won_' + tier.percent, { discount: tier.percent });
      window.setTimeout(function () { setStep('form'); }, (reduced || via === 'button') ? 80 : 680);
    }

    function checkProgress() {
      if (revealed) return;
      if (scratchedPercent() >= (cfg.threshold || 55)) complete('scratch');
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (revealed) return;
      e.preventDefault();
      drawing = true;
      lastPt = null;
      cardRect = card.getBoundingClientRect();
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      onScratchStart();
      scratchTo(pointFromEvent(e), true);
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drawing || revealed) return;
      e.preventDefault();
      scratchTo(pointFromEvent(e), false);
      if (++moveCount % 9 === 0) checkProgress();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      canvas.addEventListener(ev, function () {
        if (!drawing) return;
        drawing = false;
        lastPt = null;
        checkProgress();
      });
    });

    if (revealBtn) {
      revealBtn.addEventListener('click', function () {
        onScratchStart();
        complete('button');
      });
    }

    var resizeT = null;
    window.addEventListener('resize', function () {
      if (!isOpen || started || revealed) return;
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(paintCanvas, 180);
    });

    /* ── E-mailstap ────────────────────────────────── */
    var busy = false, sent = false;

    function showError(msg) {
      errEl.textContent = msg;
      errEl.classList.add('is-visible');
      emailInput.classList.add('is-invalid');
    }
    function hideError() {
      errEl.classList.remove('is-visible');
      emailInput.classList.remove('is-invalid');
    }
    emailInput.addEventListener('input', hideError);

    /* Shopify's botprotectie injecteert een hCaptcha-token in het formulier.
       Zonder dat token weigert /contact de POST met HTTP 400, dus dit moet
       gebeuren voor het serialiseren. Blijft de captcha hangen, dan gaan we
       na 8s door in plaats van de bezoeker te laten wachten. */
    function protectForm(el) {
      var p = null;
      try {
        if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
          p = Promise.resolve(window.Shopify.captcha.protect(el));
        }
      } catch (e) {}
      if (!p) return Promise.resolve();
      return Promise.race([
        p['catch'](function () {}),
        new Promise(function (resolve) { window.setTimeout(resolve, 8000); })
      ]);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || sent) return;

      var email = (emailInput.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        showError(cfg.t.invalid);
        try { emailInput.focus(); } catch (err) {}
        return;
      }

      busy = true;
      hideError();
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      submitLabel.textContent = cfg.t.sending;
      track('scratch_popup_email_submitted', { discount: tier.percent });

      var optin = !!(consentInput && consentInput.checked);
      if (tagsInput) {
        tagsInput.value = 'scratch-popup,scratch-' + tier.percent + (optin ? ',marketing-optin' : ',code-only');
      }
      if (optinInput) {
        optinInput.value = 'true';
        optinInput.disabled = !optin;
      }

      protectForm(form)
        .then(function () {
          return fetch(form.getAttribute('action') || '/contact', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'text/html' }
          });
        })
        .then(function (res) {
          if (!res.ok && res.status !== 302) throw new Error('HTTP ' + res.status);
          if (res.url && res.url.indexOf('/challenge') > -1) {
            console.warn('[HPSP] Shopify vroeg om een captcha-challenge; inschrijving mogelijk niet opgeslagen. Kortingscode wordt wel getoond.');
          }
          onEmailSuccess();
        })
        ['catch'](function (err) {
          /* De korting is al onthuld en Shopify valideert de code alsnog bij
             de kassa, dus we tonen hem hoe dan ook in plaats van de bezoeker
             met een foutmelding te blokkeren. */
          console.warn('[HPSP] E-mail opslaan mislukt:', err);
          track('scratch_popup_email_error', { discount: tier.percent });
          onEmailSuccess();
        });
    });

    function onEmailSuccess() {
      sent = true;
      busy = false;
      state = saveState({ done: true });
      if (codeEl && tier.code) codeEl.textContent = tier.code;
      setStep('success');
      track('scratch_popup_email_success', { discount: tier.percent });
    }

    /* ── Code kopieren ─────────────────────────────── */
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = tier && tier.code ? tier.code : '';
        if (!code) return;
        function done() {
          copyBtn.classList.add('is-copied');
          copyLabelEl.textContent = cfg.t.copied;
          track('scratch_popup_code_copied', { discount: tier.percent, code: code });
          window.setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            copyLabelEl.textContent = cfg.t.copy;
          }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallback(); });
        } else { fallback(); }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    }

    /* ── Shop-knop ─────────────────────────────────── */
    if (shopBtn) {
      shopBtn.addEventListener('click', function () {
        track('scratch_popup_shop_click', { discount: tier ? tier.percent : null });
        unlockScroll();
      });
    }
  });
})();
